// @vendors
import { useEffect, useContext, useState } from "react";
import { Form, Input, Modal } from "antd";
import Context from "../../../context/appContext";
import {
  getDate,
  getDependencyValue,
  getUrl,
  getValueField,
  getValueTypePerson,
} from "../../../utils/utils";
import cx from "classnames";
import moment from "moment";

export default function TextField({ info, form, key, current }) {
  let validate = info.validate ? info.validate : {};
  const [fieldValueEqual, setFieldValueEqual] = useState("");
  const [isDescripcion, setIsDescripcion] = useState(false);
  const [message, setMessage] = useState({ help: "", status: "success" });
  const {
    dataForm: { data, formResponses, hiddenFields, disabledFields },
    setDataForm,
    customRequest,
    loadingProcedure,
    setLoadingProcedure,
    checked,
  } = useContext(Context);

  const logic = info && info.logic && info.logic[0] ? info.logic[0] : [];
  const json = logic.trigger && logic.trigger.json ? logic.trigger.json : {};

  const keysItems = {
    primerNombreAsegurado: false,
    emailAsegurado: false,
    codigoPostalAsegurado: true,
    codigoPostalContratante: checked ? true : false,
    identificadorPersonaContratante: checked ? true : false,
  };

  const keysHidden = {
    identificadorPersonaContratanteMoral: true,
    fechaDeConstitucionContratante: true,
  };

  const keysRFC = {
    identificadorPersonaContratante: true,
    identificadorPersona: true,
    identificadorPersonaContratanteMoral: true,
  };

  const keysValidate = {
    codigoPostal: true,
    emailAsegurado: true,
    emailContratante: true,
  };

  const keysLength = {
    primerApellidoAsegurado: true,
    segundoApellidoAsegurado: true,
    calleNumInteriorAsegurado: true,
    nExteriorAsegurado: true,
    razonSocialContratante: true,
    primerNombreContratante: true,
    primerApellidoContratante: true,
    calleNumInteriorContratante: true,
    nExteriorContratante: true,
  };

  const keyNames = {
    primerNombreAsegurado: "primerNombreAsegurado",
    primerNombreContratante: "primerNombreContratante",
    emailAsegurado: "emailAsegurado",
  };

  const keyExterior = {
    nExteriorAsegurado: "nExteriorAsegurado",
    nExteriorContratante: "nExteriorContratante",
  };

  const keysTrim = {
    primerNombreAsegurado: true,
    segundoNombreAsegurado: true,
    direccionAsegurado: true,
    nExteriorAsegurado: true,
    nExteriorContratante: true,
    emailAsegurado: true,
    primerApellidoAsegurado: true,
    segundoApellidoAsegurado: true,
    calleNumInteriorAsegurado: true,
    calleNumInteriorContratante: true,
    primerNombreContratante: true,
    razonSocialContratante: true,
    primerApellidoContratante: true,
    direccionContratante: true,
  };

  useEffect(() => {
    getDefaultValue();
    if (formResponses.findIndex((x) => x.key === info.key) === -1) {
      formResponses.push(info);
    }
    if (info.properties && info.properties.equal) {
      const keyFieldEqual = info.properties.equal;
      const fieldValEqual = formResponses && formResponses.find((t) => t.key.includes(keyFieldEqual));
      setFieldValueEqual(fieldValEqual ? fieldValEqual.value : "");
    }
  }, []);

  useEffect(() => {
    setIsDescripcion(false);
  }, [checked]);

  useEffect(() => {
    disabledFields[info.key] && getDefaultValue();
  }, [disabledFields[info.key]]);

  const onChange = (event) => {
    setIsDescripcion(false);
    if (info.key === "codigoPostal") {
      form.resetFields([
        "estadoAsegurado",
        "coloniaAsegurado",
        "ciudadAsegurado",
        "municipioAsegurado",
      ]);
    } else if (info.key === "codigoPostalContratante") {
      form.resetFields([
        "estadoContratante",
        "coloniaContratante",
        "ciudadContratante",
        "municipioContratante",
      ]);
    }
    let value = event?.target?.value?.toString().trim();
    if (fieldValueEqual) {
      setMessage(
        fieldValueEqual !== value
          ? { help: "Correo electrónico no coincide", status: "error" }
          : { help: "", status: "success" }
      );
    } else {
      setValue(
        info.key.includes("identificadorPersona") ? value.toUpperCase() : value
      );
    }
    if (info.validate && info.validate.maxLength === value.length) {
      setTimeout(() => {
        setIsDescripcion(false);
      }, 2000);
      setIsDescripcion(true);
    }
    if (
      info &&
      keysLength[info.key] &&
      value.length < 1 &&
      !keysItems[info.key] &&
      checked === "personaFisica"
    ) {
      setMessage({ help: info.errorLabel, status: "error" });
    } else {
      setMessage({ help: "", status: "success" });
    }
  };

  const configModal = (message, btnOk, title) => {
    Modal.info({
      icon: "",
      title: title,
      className: "modal-confirm",
      closable: false,
      okButtonProps: {
        className: "ant-btn-solid c-2 ant-btn-size-xs margin-s",
      },
      okText: btnOk,
      content: <p>{message}</p>,
      onOk() { },
    });
  };

  const setInternalIdentifier = (dataI) => {
    const fValue = dataI && dataI.numeroInterno;
    const nField = {
      key: "internalIdentifierContratante",
      value: fValue?.toString(),
    };
    const index = formResponses.findIndex(
      (x) => x.key === "internalIdentifierContratante"
    );
    index != -1
      ? (formResponses[index].value = fValue)
      : formResponses.push(nField);
  };

  const autoComplete = (response, keyBtn) => {
    setInternalIdentifier(response);
    const keys = Object.keys(response);
    if (info.key === "validarRfc") {
      form.resetFields(["ciudadAsegurado", "municipioAsegurado"]);
    } else if (info.key === "validarRfcContratante") {
      form.resetFields(["ciudadContratante", "municipioContratante"]);
    }
    keys && keys.length > 0 && keys.forEach((val) => {
      let keyLcl = keyBtn ? val === "provinciaDomicilio" && keyBtn === "Contratante" ? "estadoContratante" : val === "colonia" ? keyBtn === "Asegurado" ? `${val}Asegurado` : `${val}Contratante` : `${val}${keyBtn}` : val;
      keyLcl = getValueTypePerson(keyLcl, formResponses);
      const item = current.newItems.find((x) => x && x.key === keyLcl);
      form.setFieldsValue({
        [keyLcl]: val === "pais" || val === "sexo" || val === "colonia" || val === "provinciaDomicilio" ? response[val].split("-")[1].replace(" ", "")
          : val === "fechaNacimiento" ? moment(response[val]).format("DD/MM/YYYY") : response[val].toString(),
      });
      if (item) {
        const value = val === "pais" || val === "sexo" || val === "colonia" || val === "provinciaDomicilio" ?
          response[val].split("-")[0].replace(" ", "") : response[val];
        const index = formResponses.findIndex((x) => x.key === keyLcl);
        const newVal = response[val].toString().split("-");
        const options = newVal && newVal.length > 1 ? [{ clave: newVal[0].replace(" ", ""), descripcion: newVal[1].replace(" ", "") }] : [];

        if (index != -1) {
          formResponses[index].value = value;
          if (keyLcl && keyLcl === "primerNombre") {
            const indexName = formResponses.findIndex((x) => x.key === "nombre");
            if (indexName !== -1) {
              const secondName = response["segundoNombre"];
              const nameComplete = secondName ? `${value} ${secondName}` : value;
              formResponses[indexName].value = nameComplete;
              formResponses[index].value = nameComplete;
              form.setFieldsValue({ [key]: nameComplete });
            }
          }

          if (item.type === "select") {
            formResponses[index].valuesResponse = options;
          }
        } else {
          item.value = value;
          if (item.type === "select") {
            item.valuesResponse = options;
          }
          formResponses.push(item);
        }

        const dependencyValue = getDependencyValue(current, keyLcl, value, []);
        if (dependencyValue && dependencyValue.length > 0) {
          dependencyValue.forEach((x) => {
            const keyItem = Object.keys(x)[0];
            form.setFieldsValue({ [keyItem]: "" });
            hiddenFields[keyItem] = checked && keysHidden[keyLcl] ? false : x[keyItem];
          });
          setDataForm({
            data,
            formResponses,
            hiddenFields: hiddenFields,
            disabledFields,
          });
        }
      }
      if (keyLcl === "codigoPostalContratante" || keyLcl === "codigoPostalAsegurado") {
        disabledFields[keyLcl] = keysItems[keyLcl];
      }
    });
    setDataForm({
      data,
      formResponses,
      hiddenFields,
      disabledFields: disabledFields,
    });
  };

  const onBlur = async (event) => {
    let value = event.target.value;
    if (
      (info && info.key.includes("identificadorPersonaAdicional")) ||
      info.key.includes("identificadorPersonaTitular")
    ) {
      const insuredDate =
        formResponses &&
        formResponses.find(
          (fr) =>
            fr.key.includes(info.key.split("-")[1]) &&
            fr.key.includes("fechaNacimiento")
        );

      if (getDate(insuredDate.value) < 18) {
        validate.minLength = 10;
        info.errorLabel = "Es necesario capturar el RFC a mínimo 10 posiciones";
        if (
          insuredDate &&
          insuredDate.value &&
          value.length >= validate.minLength &&
          value.length < validate.maxLength
        ) {
          const nValue = value.padEnd(validate.maxLength, "0");
          form.setFieldsValue({ [info.key]: nValue });
          setValue(nValue);
        }
      }
    }

    if (info && keysRFC[info.key]) {
      if (json.action === "autocomplete") {
        setLoadingProcedure({ visible: true, message: "Validando RFC..." });
        const opciones_servicio = getUrl(JSON.stringify(json), formResponses);
        const response = await customRequest(
          opciones_servicio.url,
          opciones_servicio.headers,
          opciones_servicio.method,
          opciones_servicio.body
        );
        if (response) {
          setLoadingProcedure({ ...loadingProcedure, visible: false });
          if (response.nombreExcepcion) {
            configModal(
              "No hemos encontrado los datos en nuestro sistema. Por favor completa el formulario",
              "Aceptar",
              "Ops!"
            );
          } else {
            const keyLcl =
              opciones_servicio && opciones_servicio.key
                ? opciones_servicio.key
                : null;
            autoComplete(response, keyLcl);
          }
        }
      }
    }
    if (info && keysTrim[info.key]) {
      value = value.trim();
      form.setFieldsValue({ [info.key]: value.toString() });
    }

    if (Number(value) && info.properties && info.properties.fixed) {
      value = Number(value).toFixed(Number(info.properties.fixed));
      if (
        new RegExp(validate.pattern).test(value) &&
        value.length <= validate.maxLength
      ) {
        form.setFieldsValue({ [info.key]: value.toString() });
        setValue(value);
      }
    }

    const dependencyValue = getDependencyValue(
      current,
      info.key,
      event.toString(),
      []
    );
    if (dependencyValue && dependencyValue.length > 0) {
      dependencyValue.forEach((item) => {
        const keyLcl = Object.keys(item)[0];
        form.setFieldsValue({ [keyLcl]: "" });
        hiddenFields[keyLcl] =
          checked && keysHidden[keyLcl] ? false : item[keyLcl];
      });
      setDataForm({
        data,
        formResponses,
        hiddenFields: hiddenFields,
        disabledFields,
      });
    }
  };

  const calculateValue = () => {
    const fieldsCalculated = formResponses.filter(
      (item) => item.calculateValue && item.type === info.type
    );
    fieldsCalculated &&
      fieldsCalculated.forEach((element) => {
        let isOk = true;
        let operation = element.calculateValue.operation;
        const calculateValueFields = element.calculateValue.fields;
        calculateValueFields &&
          calculateValueFields.length > 0 &&
          calculateValueFields.forEach((field) => {
            const fieldInfo = formResponses.find(
              (value) => value.key === field
            );
            const regex = new RegExp(field, "ig");
            operation = operation.replace(regex, fieldInfo && fieldInfo.value);
            if (
              !(
                fieldInfo &&
                fieldInfo.value &&
                new RegExp(fieldInfo.validate.pattern).test(fieldInfo.value)
              )
            )
              isOk = false;
          });
        if (isOk && operation) {
          try {
            const index = formResponses.findIndex((x) => x.key === element.key);
            const result = eval(operation).toFixed(
              formResponses[index].properties &&
              formResponses[index].properties.fixed
            );
            formResponses[index].value = result;
            form.setFieldsValue({ [formResponses[index].key]: result });
          } catch (error) { }
        }
      });
  };

  const setValue = (value) => {
    const index = formResponses.findIndex((x) => x.key === info.key);
    if (validate.pattern) {
      const pattern = new RegExp(validate.pattern).test(value);
      info.value = pattern ? value : "";
      index != -1
        ? (formResponses[index].value = pattern ? value : "")
        : formResponses.push(info);
    } else {
      info.value = value;
      index != -1
        ? (formResponses[index].value = value)
        : formResponses.push(info);
    }
    calculateValue();
  };

  const getDefaultValue = () => {
    const chkData = formResponses.find((item) => item.key === "datosContratanteIgualAsegurado");
    const hasCheckLoadLastStepInfo = current.newItems.find((x) => x && x.key === "datosContratanteIgualAsegurado");

    let value = "";
    if (info.customDefaultValue && (!hasCheckLoadLastStepInfo || (hasCheckLoadLastStepInfo && chkData && chkData.value))) {
      const item = formResponses.find((x) => x.key && x.key.includes(info.customDefaultValue));
      value = item && item.value ? item.value.toString() : "";
      if (keyNames[info.key]) {
        const valueItem = getValueField(keyNames[info.key], formResponses);
        if (valueItem) {
          value = valueItem;
        }
      }
      disabledFields[info.key] = !keysItems[info.key] ? keysItems[info.key] : true;
      setDataForm({
        data,
        formResponses,
        hiddenFields,
        disabledFields: disabledFields,
      });
    } else if (info && info.value && info.value !== null && info.value !== "") {
      value = info.value;
    }

    if (value && value !== "") {
      form.setFieldsValue({ [info.key]: value.toString() });
      onChange({ target: { value: value } });
    }
    setIsDescripcion(false);
  };

  const onKeyDownValidate = (e) => {
    if (info && keysValidate[info.key]) {
      if (/[^\s]/.test(e.key)) {
        return true;
      }
      e.preventDefault();
      return false;
    }
  };

  const onKeyUpValidate = ({ target }) => {
    if (info && keysValidate[info.key]) {
      const value = target.value.trim();
      setValue(value);
      form.setFieldsValue({ [info.key]: value.toString() });
    }
  };

  return (
    <div
      id={info.key}
      style={{
        position: "relative",
        display: hiddenFields[info.key] ? "none" : "block",
      }}
    >
      <Form.Item
        label={info.label}
        name={info.key}
        key={key}
        hidden={hiddenFields[info.key]}
        className={cx(
          {
            "ant-form-item-disabled": info.disabled,
          },
          {
            uppercase: info.key.includes("identificadorPersona") || info.key.includes("serialNumber"),
          }
        )}
        rules={[
          {
            min: validate.minLength ? validate.minLength : 1,
            max: validate.maxLength ? validate.maxLength : 100,
            message:
              info && info && info.errorLabel
                ? info.errorLabel
                : "Longitud de carácteres no válido",
          },
          {
            required:
              hiddenFields[info.key] ||
                disabledFields[info.key] ||
                info.disabled
                ? false
                : validate.required,
            message: "Campo obligatorio",
          },
          {
            pattern: new RegExp(validate.pattern),
            message: validate.customMessage,
          },
          {
            pattern: new RegExp(message.status === "error" ? "error" : ""),
            message: message.help,
          },
        ]}
        tooltip={info.tooltip ? info.tooltip : null}
      >
        <Input
          placeholder={info.placeholder}
          id={info.key}
          onCopy={(e) => {
            if (
              info &&
              (info.key === "emailAsegurado" || info.key === "emailContratante")
            ) {
              e.preventDefault();
              return false;
            }
          }}
          data-testid="text-input"
          readOnly={info.hidden}
          disabled={disabledFields[info.key]}
          minLength={validate.minLength}
          maxLength={validate.maxLength}
          onChange={onChange}
          onBlur={(ev) => {
            if (new RegExp(validate.pattern).test(ev.target.value)) {
              onBlur(ev);
            }
          }}
          autoComplete="off"
          onKeyDown={(e) => onKeyDownValidate(e)}
          onKeyUp={(e) => onKeyUpValidate(e)}
          onInput={e => e.target.value = info.key.includes("serialNumber") ? e.target.value.toUpperCase(): e.target.value}
        />
      </Form.Item>
      {info && info.description && isDescripcion && (
        <div className="ant-text-description">{`${info.description} ${info.validate.maxLength}`}</div>
      )}
    </div>
  );
}
